import App from 'app/app.js';
import 'app/directive/LtEnhancedPayonlyContinueShoppingCtrl.js';

function LtEnhancedPayonlyContinueShoppingDirective() {
  return {
    restrict: 'E',
    scope: {
      onContinue: '&',
      onCancel: '&',
      subjectFirstName: '=',
      portraitId: '=',
      accessCode: '='
    },
    template:
      '<div class="bottom-drawer bottom-drawer-alignment lt-enhanced-pay-only-continue-shopping-modal"' +
      ' lt-drawer-cancellation="continueShoppingCtrl.cancel()" ng-init="continueShoppingCtrl.init()">' +
      '       <form name="continueShoppingForm" id="lt-enhanced-pay-only-continue-shopping-form"' +
      ' ng-submit="continueShoppingCtrl.onContinue()"' +
      ' class="fpd"' +
      ' ng-if="!continueShoppingCtrl.showFindCredentials">' +
      '	    <div class="modal-spec-continue-shopping">' +
      '           <div class="col-xs-12" ng-class="{\'modal-spec-header\' : portraitId != null}">' +
      '               <h3 class="text-center"><b lt-translate="ENHANCED_PAY_ONLY_CONTINUE_SHOPPING"></b></h3>' +
      '               <h3 class="text-center"><b>{{subjectFirstName}}</b></h3>' +
      '           </div>' +
      '           <div class="col-xs-12 spec-modal-instructions" ng-show="portraitId === null">' +
      '               <p class="text-center" lt-translate="ENHANCED_PAY_ONLY_ENTER_PORTRAIT"></p>' +
      '           </div>' +
      '           <div>' +
      '               <a ng-click="continueShoppingCtrl.toggleFindCredentials()" lt-translate="ENHANCED_PAY_ONLY_CONTINUE_SHOPPING_WHERE_ARE_CREDENTIALS"></a>' +
      '           </div>' +
      '           <div class="row" ng-show="portraitId === null">' +
      '               <div class="col-xs-12 noRightOrLeftPadding">' +
      '                   <fieldset ng-class="{valid: continueShoppingCtrl.isPortraitIdValid()}">' +
      '                       <input type="text" class="portrait-id" lt-focus="!continueShoppingCtrl.isPortraitIdValid()" lt-key-filter="name" maxlength="10" ng-model="continueShoppingCtrl.portraitId" placeholder=\'{{continueShoppingCtrl.getPlaceholder("ENHANCED_PAY_ONLY_CONTINUE_SHOPPING_PORTRAIT_ID_PLACEHOLDER")}}\'' +
      ' data-test-portrait-id/>' +
      '                   </fieldset>' +
      '               </div>' +
      '               <div class="col-xs-12 noRightOrLeftPadding">' +
      '                   <fieldset ng-class="{valid: continueShoppingCtrl.isAccessCodeValid()}" >' +
      '                       <input type="text" name="accessCode" lt-key-filter="name" maxlength="4" ng-model="continueShoppingCtrl.accessCode" placeholder=\'{{continueShoppingCtrl.getPlaceholder("ENHANCED_PAY_ONLY_CONTINUE_SHOPPING_ACCESS_CODE_PLACEHOLDER")}}\' required data-test-access-code/>' +
      '                   </fieldset>' +
      '                   <fieldset ng-class="{valid: continueShoppingCtrl.isSubjectLastNameValid()}" >' +
      '    <input type="text" name="subjectLastName" maxlength="50" lt-key-filter="name" ng-model="continueShoppingCtrl.subjectLastName" placeholder=\'{{continueShoppingCtrl.getPlaceholderByCountry("PICTURE_DAY_FORM_LAST_NAME")}}\' data-test-subject-last-name/>' +
      '                   </fieldset>' +
      '                   <input type="reset" tabIndex="-1" id="resetForm" role="button"' +
      ' value=\'{{continueShoppingCtrl.getPlaceholderByCountry("PICTURE_DAY_FORM_RESET_TEXT")}}\' ng-click="continueShoppingCtrl.resetFormValues()"/>' +
      '               </div>' +
      '           </div>' +
      '           <div class="row">' +
      '               <div class="col-xs-10 col-xs-push-1 noRightOrLeftPadding">' +
      '                   <input class="lt-primary-button" role="button" type="submit" value=\'{{continueShoppingCtrl.getPlaceholderByCountry("PICTURE_DAY_FORM_SHOP_NOW_TEXT")}}\' ng-disabled="continueShoppingCtrl.disableShopNowButton()" data-test-shop-now-btn/>' +
      '               </div>' +
      '           </div>' +
      '	        <div align="center">' +
      '	            <div class="cancel spec-modal-cancel-link">' +
      '	                <a ng-click="continueShoppingCtrl.close()" lt-translate="COMMON_TEXT_CANCEL"></a>' +
      '	            </div>' +
      '	        </div>' +
      '	        <div class="row">' +
      '	            <div class="text-center spec-modal-disclaimer">' +
      '	                <p lt-translate="ENHANCED_PAY_ONLY_CONTINUE_SHOPPING_DISCLAIMER"></p>' +
      '	            </div>' +
      '	        </div>' +
      '	    </div>' +
      '   </form>' +
      '	<div class="modal-spec-continue-shopping" ng-if="continueShoppingCtrl.showFindCredentials">' +
      '       <div class="col-xs-12 noRightOrLeftPadding">' +
      '	        <h3 class="text-center"><b lt-translate="ENHANCED_PAY_ONLY_FIND_CREDENTIALS"></b></h3>' +
      '       </div>' +
      '       <div class="col-xs-10 col-xs-push-1 spec-modal-instructions text-center noRightOrLeftPadding">' +
      '           <p lt-translate="ENHANCED_PAY_ONLY_FIND_CREDENTIALS_COPY"></p>' +
      '	        <h6 lt-translate="ENHANCED_PAY_ONLY_FIND_CREDENTIALS_NOTE"></h6>' +
      '        </div>' +
      '        <div class="col-xs-12 noRightOrLeftPadding spec-modal-find-credentials-image">' +
      '           <img lt-translate-src="ENHANCED_PAY_ONLY_FIND_CREDENTIALS_IMAGE"/>' +
      '       </div>' +
      '	     <div class="col-xs-12" align="center">' +
      '	         <div class="spec-modal-find-credentials-cancel">' +
      '               <span class="spec-modal-find-credentials-ok">' +
      '	                <a ng-click="continueShoppingCtrl.toggleFindCredentials()"></a>' +
      '               </span>' +
      '               <a ng-click="continueShoppingCtrl.toggleFindCredentials()" lt-translate="ENHANCED_PAY_ONLY_FIND_CREDENTIALS_OK"></a>' +
      '	         </div>' +
      '	     </div>' +
      '	</div>',
    controller: 'LtEnhancedPayonlyContinueShoppingCtrl',
    controllerAs: 'continueShoppingCtrl'
  };
}

App.directive('ltEnhancedPayonlyContinueShopping', [LtEnhancedPayonlyContinueShoppingDirective]);
